import { render, staticRenderFns } from "./TileDataGemeenteprognose.vue?vue&type=template&id=c31bc058&"
import script from "./TileDataGemeenteprognose.vue?vue&type=script&lang=js&"
export * from "./TileDataGemeenteprognose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports